export default {
    methods: {},
    loader: true,
    shippingVia: '',
};
